import { SEARCH_BIKE_REQUEST, SEARCH_BIKE_REQUEST_SUCCESS, SEARCH_BIKE_REQUEST_FAILURE } from '../constants/bike_model.constants';

export const searchBikeRequest = payload => ({
    type: SEARCH_BIKE_REQUEST, payload,
});

export const searchBikeRequestSuccess = payload => ({
    type: SEARCH_BIKE_REQUEST_SUCCESS, payload,
});

export const searchBikeRequestFailure = error => ({
    type: SEARCH_BIKE_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/search_bike.actions.js